import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  departamentos: [],
  operadores: [],
  filas: [],
  pausas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
